// The preview mode every picture in the app shares: live (MJPEG while it
// is shown) or a still every 2 s, remembered per browser; and whether the
// page is hidden (a hidden tab streams nothing: it kept streaming).
import { ref } from 'vue'

function stored(): boolean {
    try {
        return localStorage.getItem('ese.preview') !== 'still'
    } catch {
        return true // private mode, or no storage
    }
}

export const previewLive = ref(stored())

export function setPreviewLive(v: boolean) {
    previewLive.value = v
    try {
        localStorage.setItem('ese.preview', v ? 'live' : 'still')
    } catch {
        /* private mode */
    }
}

export const pageHidden = ref(typeof document !== 'undefined' && document.hidden)
if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => (pageHidden.value = document.hidden))
}

// v-stream on a live (MJPEG) <img>: when it leaves the page its source is
// cleared first, which ends the stream. Chromium does not reliably abort a
// multipart/x-mixed-replace fetch whose <img> is removed, so each tab switch
// could leave the node a preview encoder running for nobody (WEB-34).
export const vStream = {
    beforeUnmount(el: HTMLImageElement) {
        el.onerror = null
        el.src = ''
    },
}
